import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container } from 'reactstrap';
import { get } from 'lodash-es';

import {
  LeadFormParamsPropTypes,
  LeadFormParamsDefaultProps,
  UnifiedLeadFormCustomConfigPropTypes,
  UnifiedLeadFormCustomConfigDefaultProps,
} from 'site-modules/shared/components/lead-form/lead-form-prop-types/lead-form-prop-types';

import { getTemplateParams, fireThankYouTracking } from 'site-modules/shared/components/lead-form/utils/utils';
import { FloodlightAd } from 'site-modules/shared/components/floodlight/floodlight-ad';

/**
 * Thank you view decorator.
 */
export function ThankYouViewDecorator(WrappedComponent, className = 'px-md-1_25 pb-1_5') {
  return class ThankYouViewDecoratorComponent extends Component {
    static propTypes = {
      ...LeadFormParamsPropTypes,
      trackingData: PropTypes.shape({
        leadIdList: PropTypes.arrayOf(PropTypes.string),
      }).isRequired,
      customConfig: UnifiedLeadFormCustomConfigPropTypes.thankYouConfig,
      userInfo: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
      }).isRequired,
      isMobile: PropTypes.bool,
      closeDrawer: PropTypes.func,
    };

    static defaultProps = {
      ...LeadFormParamsDefaultProps,
      customConfig: UnifiedLeadFormCustomConfigDefaultProps.thankYou,
      isMobile: false,
      closeDrawer: null,
    };

    constructor(props) {
      super(props);
      this.thankYou = React.createRef();
    }

    componentDidMount() {
      const {
        leadTargets,
        trackingData,
        customConfig: { isSimulatedLeadForm },
      } = this.props;

      fireThankYouTracking({
        leadTargets,
        trackingData: { ...trackingData },
        target: this.thankYou.current,
        isSimulatedLeadForm,
      });
    }

    render() {
      const { suggestedLeadTargets, customConfig } = this.props;
      const {
        headerConfig,
        withFormClasses,
        adsConfig,
        className: thankYouClassName,
        ...otherCustomConfig
      } = customConfig;
      const { adComponent: AdComponent, ...otherAdsConfig } = adsConfig;
      const wrappedProps = {
        ...this.props,
        customConfig: {
          ...otherCustomConfig,
        },
      };
      const {
        headerComponent: HeaderComponent,
        header,
        subHeaderComponent: SubHeaderComponent,
        subHeader,
      } = headerConfig;

      const templateParams = getTemplateParams(this.props);
      const skipSubHeader =
        subHeader.skipWhenSuggestedLeadTargetsEmpty && suggestedLeadTargets && suggestedLeadTargets.length === 0;
      const isNewVinOnSrp = get(customConfig, 'isNewVinOnSrp', false);

      return (
        <div
          ref={this.thankYou}
          className={classNames('base-template mx-auto', thankYouClassName, { [className]: withFormClasses })}
        >
          {HeaderComponent && <HeaderComponent config={header} templateParams={templateParams} />}
          {!skipSubHeader && SubHeaderComponent && (
            <SubHeaderComponent config={subHeader} templateParams={templateParams} />
          )}
          <WrappedComponent {...wrappedProps} />
          {AdComponent && !isNewVinOnSrp && (
            <Container>
              <AdComponent config={otherAdsConfig} />
            </Container>
          )}
          {AdComponent && isNewVinOnSrp && (
            <div className="px-1 px-md-3_5">
              <AdComponent config={otherAdsConfig} />
            </div>
          )}
          <FloodlightAd />
        </div>
      );
    }
  };
}
